import {AGENT_OBSERVATION_LIMIT} from 'app/utils/constants';

export const CONTACT_DIALOG_COPY = {
  'custom-prompt': {
    title: 'Custom prompts',
    message:
      'Have something specific you want the Agent to look for? We can implement and optimize custom prompts for your organization!',
    emailSubject: 'Lens Agent custom prompt',
    emailBody:
      "Hello Lens team,\n\nI'd like the Agent to look for something specific. Here's what I'm looking for:\n\n",
  },
  quota: {
    title: 'Increase your run quota',
    message: 'Running out of runs? Send us a message and we can increase your quota.',
    emailSubject: 'Lens Agent run quota increase',
    emailBody: "Hello Lens team,\n\nI'd like to increase my organization's Agent run quota.\n\n",
  },
  'observation-limit': {
    title: 'Observation limit reached',
    // The run-panel callout appends its own "Reach out to us at ..." line, so this stops short of asking.
    message: `This run reached the trial limit of ${AGENT_OBSERVATION_LIMIT} observations. If you'd like to explore more, we can talk through options for next steps.`,
    emailSubject: 'Lens Agent observation limit',
    emailBody:
      "Hello Lens team,\n\nMy Agent run reached the observation limit and I'd like to explore options for looking at more of my property.\n\n",
  },
} as const;

export type ContactDialogVariant = keyof typeof CONTACT_DIALOG_COPY;
